import { useCallback } from 'react';

import { buildInitialMergeFields } from '../components/intakes/utils/mergeFieldToIntakePatch';
import { useConvertToMatter } from './useConvertToMatter';
import { useIntakeArchive } from './useIntakeArchive';
import { useIntakeExport } from './useIntakeExport';
import { useIntakeForm } from './useIntakeForm';
import { useIntakeRetainer } from './useIntakeRetainer';

export const useIntakePage = (intakeId: string | null, isNew: boolean) => {
  const { latestEngagementLetter, refetchIntakeDocuments } = useIntakeRetainer({
    intakeId,
  });

  // ----- core intake form -----
  const intake = useIntakeForm(intakeId, isNew);

  // ----- export helpers -----
  const exportHelpers = useIntakeExport({
    intakeId,
  });

  // ----- convert-to-matter helpers -----
  const conversion = useConvertToMatter({
    intakeId,
    matterId: intake.matterId,
    matterStatus: intake.matterStatus,
    leadSource: intake.form.leadSource,
    referralSource: intake.form.referralSource.description,
    manualQualification: intake.manualQualification,
    intakeStatus: intake.status,
    hasLinkedLead: intake.hasLinkedLead,
  });

  // ----- archive helpers -----
  const archiveHelpers = useIntakeArchive({
    intakeId,
    isArchived: intake.status === 'Archived',
  });

  // LOE document id tracking

  // Use colocated mapping utility for merge fields
  const buildInitialMergeFieldsRef = useCallback(buildInitialMergeFields, []);

  const handleEngagementSent = useCallback(
    async (intakeIdParam: string, documentId: string) => {
      intake.handleStatusChange({
        ...intake.intakeStatuses,
        loeStatus: 'Sent',
      });

      await refetchIntakeDocuments();
    },
    [intake, refetchIntakeDocuments],
  );

  return {
    intake,
    exportHelpers,
    archiveHelpers,
    conversion,
    loeDocumentId: latestEngagementLetter?.id,
    buildInitialMergeFields: buildInitialMergeFieldsRef,
    handleEngagementSent,
    refetch: intake.refetch,
  } as const;
};
